import { Component } from '@angular/core';
import {
  InputComponent,
  MenuComponent,
  MenuItemComponent,
  MenuTriggerComponent,
} from '@group24ag/flowkit';
import { FormControl, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: `app-ui-menu`,
  imports: [
    InputComponent,
    MenuComponent,
    MenuItemComponent,
    MenuTriggerComponent,
    ReactiveFormsModule,
  ],
  template: `
    <div>
      <h1 class="heading-title">Menu</h1>
      <div class="flex flex-col gap-10">
        <ng-template #menu>
          <flk-menu>
            @for (item of items; track $index) {
              <div flkMenuItem>{{ item }}</div>
            }
          </flk-menu>
        </ng-template>
        <div flkMenuTrigger [triggerFor]="menu">Open Menu</div>

        <ng-template #menuScroll>
          <flk-menu>
            @for (item of longItems; track $index) {
              <div flkMenuItem>{{ item }}</div>
            }
          </flk-menu>
        </ng-template>
        <div flkMenuTrigger [triggerFor]="menuScroll">Open scrollable Menu</div>

        <ng-template #menuInputs>
          <flk-menu>
            <div class="flex flex-col gap-5">
              <flk-input
                [placeholder]="'First name'"
                [formControl]="firstName"></flk-input>
              <flk-input
                [placeholder]="'Second name'"
                [formControl]="secondName"></flk-input>
            </div>
          </flk-menu>
        </ng-template>
        <div flkMenuTrigger [triggerFor]="menuInputs">
          Open menu with inputs
        </div>
      </div>
    </div>
  `,
})
export class UIMenuComponent {
  firstName = new FormControl();
  secondName = new FormControl();
  items = ['Item 1', 'Item 2', 'Item 3'];
  longItems = [
    'Item 1',
    'Item 2',
    'Item 3',
    'Item 4',
    'Item 5',
    'Item 6',
    'Item 7',
    'Item 8',
    'Item 8',
    'Item 8',
    'Item 8',
    'Item 8',
  ];
}
